import classNames from 'classnames';
import { ReactComponent as SvgCloudy } from 'public/assets/icons/weatherType/cloudy.svg';
import { ReactComponent as SvgFog } from 'public/assets/icons/weatherType/fog.svg';
import { ReactComponent as SvgSnow } from 'public/assets/icons/weatherType/snow.svg';
import { ReactComponent as SvgFair } from 'public/assets/icons/weatherType/fair.svg';
import { ReactComponent as SvgRainShowers } from 'public/assets/icons/weatherType/rain_showers.svg';
import { ReactComponent as SvgSleetShowers } from 'public/assets/icons/weatherType/sleet_showers.svg';
import { ReactComponent as SvgSnowShowers } from 'public/assets/icons/weatherType/snow_showers.svg';
import { ReactComponent as SvgLune } from 'public/assets/icons/weatherType/lune.svg';
import { ReactComponent as SvgMostlySunny } from 'public/assets/icons/weatherType/mostly_sunny.svg';
import { ReactComponent as SvgSlightlyCloudy } from 'public/assets/icons/weatherType/slightly_cloudy.svg';
import { ReactComponent as SvgOvercas } from 'public/assets/icons/weatherType/overcas.svg';
import { ReactComponent as SvgThunderstorm } from 'public/assets/icons/weatherType/thunderstorm.svg';
import { ReactComponent as SvgPartlyCloudy } from 'public/assets/icons/weatherType/partly_cloudy.svg';
import { ReactComponent as SvgRain } from 'public/assets/icons/weatherType/rain.svg';
import { ReactComponent as SvgLightRain } from 'public/assets/icons/weatherType/light_rain.svg';
import { ReactComponent as SvgSleet } from 'public/assets/icons/weatherType/sleet.svg';
// import { ReactComponent as SvgHurricane } from 'public/assets/icons/weatherType/hurricane.svg';
import { ReactComponent as SvgSunny } from 'public/assets/icons/weatherType/sunny.svg';
import { WeatherType } from 'types';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { weatherTypeMap } from 'util/weatherTypeMap';
import styles from './styles.module.scss';

const showIcon = (title: WeatherType) => {
  switch (title) {
    case 'PARTLY_CLOUDY': {
      return <SvgPartlyCloudy />;
    }
    case 'CLOUDY': {
      return <SvgCloudy />;
    }
    case 'RAIN': {
      return <SvgRain />;
    }
    case 'SNOW': {
      return <SvgSnow />;
    }
    case 'LIGHT_RAI': {
      return <SvgLightRain />;
    }
    case 'SLEET': {
      return <SvgSleet />;
    }
    case 'FOG': {
      return <SvgFog />;
    }
    case 'SUN': {
      return <SvgSunny />;
    }
    case 'FAIR': {
      return <SvgFair />;
    }
    case 'RAIN_SHOWERS': {
      return <SvgRainShowers />;
    }
    case 'SLEET_SHOWERS': {
      return <SvgSleetShowers />;
    }
    case 'SNOW_SHOWERS': {
      return <SvgSnowShowers />;
    }
    case 'OVERCAS': {
      return <SvgOvercas />;
    }
    case 'SLIGHTLY_CLOUDY': {
      return <SvgSlightlyCloudy />;
    }
    case 'MOSTLY_SUNNY': {
      return <SvgMostlySunny />;
    }
    case 'LUNE': {
      return <SvgLune />;
    }
    case 'THUNDERSTORM': {
      return <SvgThunderstorm />;
    }
    default: {
      return null;
    }
  }
};

export const IconWeather = (
  { title, className }: { title?: WeatherType, className?: string },
) => {
  const { t } = useOTSTranslation('common');

  return (
    <div className={classNames(styles.iconWeather, className)}>
      {title
        ? (
          <div title={t(weatherTypeMap[title])}>
            {showIcon(title)}
            <span className={styles.h4}>{t(weatherTypeMap[title])}</span>
          </div>
        ) : (<></>)}
    </div>
  );
};
